import { render, staticRenderFns } from "./QuickPay.vue?vue&type=template&id=0979a589"
import script from "./QuickPay.vue?vue&type=script&lang=js"
export * from "./QuickPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports